import {
  CalendarDaysIcon,
  CheckCircleIcon,
  CurrencyDollarIcon,
  formatNumber,
  GradientCard,
  LockClosedIcon,
  UserGroupIcon,
} from "@";

// Renders the numbers for the Statistic.

const Numbers = ({ numbers }) => {
  return (
    <div className="mb-5 grid gap-3 md:grid-cols-2 md:gap-5 lg:grid-cols-3 print:hidden">
      {/* totalDonations */}
      <GradientCard
        number={formatNumber(numbers?.totalDonations)}
        title="إجمالي مبلغ التبرعات"
      >
        <CurrencyDollarIcon className="h-9 w-9" />
      </GradientCard>

      {/* donorsThisMonth */}
      <GradientCard
        number={formatNumber(numbers?.donorsThisMonth)}
        title="متبرعين الشهر الحالي"
      >
        <UserGroupIcon className="h-9 w-9" />
      </GradientCard>

      {/* donationsThisMonth */}
      <GradientCard
        number={formatNumber(numbers?.donationsThisMonth)}
        title="تبرعات الشهر الحالي"
      >
        <CalendarDaysIcon className="h-9 w-9" />
      </GradientCard>

      {/* donorsTotalCount */}
      <GradientCard
        number={formatNumber(numbers?.donorsTotalCount)}
        title="إجمالي المتبرعين"
      >
        <UserGroupIcon className="h-9 w-9" />
      </GradientCard>

      {/* pendingDonations */}
      <GradientCard
        number={formatNumber(numbers?.pendingDonations)}
        title="التبرعات في إنتظار المراجعة"
      >
        <LockClosedIcon className="h-9 w-9" />
      </GradientCard>

      {/* donationsThisDay */}
      <GradientCard
        number={formatNumber(numbers?.donationsThisDay)}
        title="تبرعات اليوم الحالي"
      >
        <CheckCircleIcon className="h-9 w-9" />
      </GradientCard>
    </div>
  );
};
export default Numbers;
